module.exports = __webpack_public_path__ + "static/media/s5-alt.f2ed56e6.png";